export default {
  title: 'Point og rabatter',
  store_credit: 'Butikskredit',
  points_balance: 'Pointsaldo',
};
